import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';
import {ConnecttocrudService} from './connecttocrud.service';

@Injectable({
  providedIn: 'root'
})
export class AuditListenerService {

    @Output() auditListener: EventEmitter<any> = new EventEmitter();


    constructor(private confPost: ConfService, public platform: LeftpanelComponent, private _service: ConnecttocrudService) {
    this.auditListener.subscribe(
        (eventObject) => {
            // This Listener has to be removed
        }
    );
  }
}
